import { z } from "zod";

import { pvReceptionHeaderSchema } from "./sections/header.js";
import { pvReceptionDeclarationsSchema } from "./sections/declarations.js";
import { pvReceptionReservesSchema } from "./sections/reserves.js";
import { pvReceptionChequeSchema } from "./sections/cheque.js";
import { pvReceptionSignaturesSchema } from "./sections/signatures.js";

/**
 * Root PV de réception payload, lenient. Drafts allow any section to be
 * missing. Completion checks live separately (see ./validation.ts).
 */
export const PV_RECEPTION_PAYLOAD_VERSION = 1 as const;

export const pvReceptionPayloadSchema = z
  .object({
    version: z.literal(PV_RECEPTION_PAYLOAD_VERSION).optional(),
    header: pvReceptionHeaderSchema.optional(),
    declarations: pvReceptionDeclarationsSchema.optional(),
    reserves: pvReceptionReservesSchema.optional(),
    cheque: pvReceptionChequeSchema.optional(),
    signatures: pvReceptionSignaturesSchema.optional(),
  })
  .partial();

export type PvReceptionPayload = z.infer<typeof pvReceptionPayloadSchema>;

export const emptyPvReceptionPayload = (): PvReceptionPayload => ({
  version: PV_RECEPTION_PAYLOAD_VERSION,
});
